import { Component, Input, inject } from '@angular/core';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';
import { AnlagentypColorService } from '../../service/anlagentyp/anlagentyp-color.service';
import { AnlagentypIconService } from '../../service/anlagentyp/anlagentyp-icon.service';
import { Anlagentyp } from '../../domain/model/anlagentyp';
import { RoutingService } from '../../service/common/routing/routing.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'tnb-erzeugungsanlage-tile',
    templateUrl: './erzeugungsanlage-tile.component.html',
    styleUrls: [
        './erzeugungsanlage-tile.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageTileComponent {
    private anlagetypColorService = inject(AnlagentypColorService);
    private anlagentypIconService = inject(AnlagentypIconService);
    routingService = inject(RoutingService);

    public ASSET_URL = environment.ASSET_URL;

    @Input()
    public erzeugungsanlage?: Erzeugungsanlage;

    public get tileColorName(): string {
        return this.anlagetypColorService.getColorNameForAnlagentyp(this.erzeugungsanlage.anlagentyp);
    }

    public get tileIconName(): string {
        return this.anlagentypIconService.getIconNameForAnlagentyp(this.erzeugungsanlage.anlagentyp);
    }

    public get anlagentype(): Anlagentyp {
        return this.erzeugungsanlage && this.erzeugungsanlage.anlagentyp;
    }
}
